// extracted by mini-css-extract-plugin
export var ctas = "#226355";
export var description = "RelatedResource-module--description--lN8i+";
export var grayBackground = "#f6f8fb";
export var imgContainer = "RelatedResource-module--imgContainer--Ffl59";
export var link = "RelatedResource-module--link--BC7KF";
export var textArrow = "RelatedResource-module--textArrow--urSK6";
export var title = "RelatedResource-module--title--uwoOE";
export var titleContainer = "RelatedResource-module--titleContainer--xNNuh";